module.exports = __webpack_public_path__ + "img/eva_pin-fill.34da18e9.svg";